/* eslint-disable no-plusplus */
import { DOMParser } from 'xmldom';

const DOCTYPE =
  '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">';
const NODE_TYPE_TEXT = 3;
class Mark {
  private dom: Document;

  private options: {
    className?: string;
    markedClassName?: string;
    style?: { [key: string]: string | undefined };
    markedStyle?: { [key: string]: string | undefined };
  };

  public matchCount: number;

  public matchedIndex: number;

  public isMarked = false;

  private hlIndex: number;

  constructor(
    content: string,
    options: {
      className?: string;
      markedClassName?: string;
      style?: { [key: string]: string | undefined };
      markedStyle?: { [key: string]: string | undefined };
    } = {
      className: 'terminal-viewer-hl-mark',
      markedClassName: 'terminal-viewer-hl-mark terminal-viewer-hl-marked',
    },
  ) {
    this.dom = new DOMParser().parseFromString(
      `${DOCTYPE}<html><body>${content}</body></html>`,
      'text/html',
    );

    this.options = options;
    this.matchCount = 0;
    this.matchedIndex = 0;
    this.isMarked = false;
    this.hlIndex = 0;
  }

  /**
   * 根据关键字标记文本
   * @param {String} keyword - 搜索关键词
   * @param {Number} options.matchedIndex - 已匹配的最大的索引
   * @param {Number} options.hlIndex - 需要标记的索引
   * @returns this
   */
  mark(keyword: string, options = { matchedIndex: 0, hlIndex: 0 }) {
    const reg = new RegExp(this.escapeStr(keyword), 'gi');
    let nodes = Array.from(this.dom.getElementsByTagName('body')[0].childNodes);
    const len = keyword.length;
    this.matchedIndex = options.matchedIndex;
    this.hlIndex = options.hlIndex;
    nodes.forEach((node) => {
      let allNodes = this.getTextNodes(node);
      allNodes.forEach((anode) => {
        let textNode = anode;
        let text = textNode.textContent || '';
        while (text) {
          const start = text.search(reg);
          if (start !== -1) {
            textNode = this.wrapRangeInTextNode(textNode as Text, start, start + len);
            text = textNode?.textContent || '';
            this.matchCount++;
            this.matchedIndex++;
          } else {
            break;
          }
        }
      });
      allNodes = [];
    });
    nodes = [];
    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  escapeStr(str: string) {
    // eslint-disable-next-line no-useless-escape
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  }

  getStyle(isMarked: boolean) {
    const style = (isMarked ? this.options.markedStyle : this.options.style) || {};
    return Object.keys(style)
      .filter((key: string) => style[key])
      .map((key) => `${key}:${style[key]};`)
      .join('');
  }

  // eslint-disable-next-line class-methods-use-this
  getTextNodes(el: ChildNode) {
    const nodes = [];
    const queue = [el];
    while (queue.length !== 0) {
      const node = queue.shift();
      if (node && node.nodeType === NODE_TYPE_TEXT) {
        nodes.push(node);
      }
      if (node && node.hasChildNodes()) {
        const childNodes = Array.from(node.childNodes);
        childNodes.forEach((cnode) => {
          if (cnode.nodeType === NODE_TYPE_TEXT) {
            nodes.push(cnode);
          }
        });
        queue.push(...childNodes);
      }
    }
    return nodes;
  }

  wrapRangeInTextNode(node: Text, start: number, end: number) {
    const { className, markedClassName } = this.options;
    const startNode = node.splitText(start);
    const ret = startNode.splitText(end - start);
    const repl = this.dom.createElement('mark');
    const style = this.getStyle(this.matchedIndex === this.hlIndex);
    if (this.matchedIndex === this.hlIndex) {
      this.isMarked = true;
    }
    repl.setAttribute(
      'class',
      (this.matchedIndex === this.hlIndex ? markedClassName : className) || '',
    );
    if (style) {
      repl.setAttribute('style', style);
    }
    repl.textContent = startNode.textContent;
    startNode.parentNode?.replaceChild(repl, startNode);
    return ret;
  }

  toString() {
    const innerHTML = this.dom.getElementsByTagName('body')[0].toString();
    const match = innerHTML.match(
      /^<body xmlns="http:\/\/www\.w3\.org\/1999\/xhtml">(.[\s\S]*?)<\/body>$/,
    );
    return match && match[1] ? match[1] : '';
  }

  distory() {
    this.dom = null as unknown as Document;
  }
}
export default Mark;
